export default __webpack_public_path__ + "soccer-live.png";